import { h, render } from 'preact';
import 'preact/debug';

import { preactWidget } from '../../utils';

import widget from './widget';
import { AutoPushNotificationsComponent } from './component';

export const hydrate = () => {
  const { $root, props } = preactWidget(widget);
  render(<AutoPushNotificationsComponent htmlProps={props.htmlProps} widget={widget} $root={$root} />, $root);
};
